import SortColumnsGantt from './SortColumnsGantt';
import './SortColumnsGantt.scss';
export default SortColumnsGantt;
